/*
 ExportMapping.js component
 url match: /template/export/:templateId
 Allows user to choose the format for exporting the mapping defined in OutputMapping component
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { templateStyles } from '../../Styles/templateStyles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Loader from 'react-loader-spinner'

@inject('templateStore', 'userStore')
@observer
class ExportMapping extends React.Component {
    state = {
        type: 'XLS'
    }


    back = () => {
        this.props.history.push(`/template/mapping/${this.props.match.params['templateId']}`)
    }

    save = () => {
        this.props.templateStore.updateExportType(this.props.match.params['templateId'])
            .then((response) => {
                if (this.props.templateStore.saveSuccess)
                    if (!this.props.userStore.isLocalTemplatePresent)
                        this.props.history.push('/dashboard/drafts')
                    else
                        this.props.history.push('/dashboard/templates')
            })
    }

    handleRadioChange = (event) => {

        this.props.templateStore.setExportType(event.target.value)
    }




    render() {
        const { classes, theme  } = this.props;
        const { inProgress, exportType, templateName } = this.props.templateStore;
        return (

            <div className={classes.mappingContainer}>
                <div className={classes.tempName}>{templateName}</div>
                <div className={classes.docHeader}><span style={{ color: theme.palette.dullGray }}> Output Mapping > </span>  Save</div>
                <div className={classes.selectContainer}>
                    <div>
                        Select Output Format
                        <RadioGroup className={classes.radioContainer} aria-label="type" value={exportType} name="exportType" onChange={this.handleRadioChange}>
                            <FormControlLabel value="XLS" control={<Radio color="primary" classes={{ root: exportType === "XLS" ? classes.activeRadio : classes.radio }} />} label="Xls" />
                            <FormControlLabel value="API" control={<Radio color="primary" classes={{ root: exportType === "API" ? classes.activeRadio : classes.radio }} />} label="API" />
                        </RadioGroup>
                    </div>
                    <div className={classes.saveContainer} style={{ paddingTop: '30vh' }}>
                        <Button variant="contained" className={classes.button} onClick={this.back} > Back  </Button>
                        {
                            inProgress ?
                                <Button variant="contained" className={classes.button} style={{ backgroundColor: theme.palette.blue }}><Loader height={30} width={30} color={this.props.theme.palette.white} /></Button> :
                                <Button variant="contained" className={classes.button} style={{ backgroundColor: theme.palette.blue }} type="submit" onClick={this.save} > Save  </Button>

                        }
                    </div>
                </div>

            </div>
        )

    }
}
export default withStyles(templateStyles, { withTheme: true })(withRouter(ExportMapping));


